/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Schoolname1Inputs */

const en__field_schoolname1 = /** @type {(inputs: _Field_Schoolname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`School Name`)
};

const de__field_schoolname1 = /** @type {(inputs: _Field_Schoolname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name der Schule`)
};

/**
* | output |
* | --- |
* | "School Name" |
*
* @param {_Field_Schoolname1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_schoolname1 = /** @type {((inputs?: _Field_Schoolname1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Schoolname1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_schoolname1(inputs)
	return de__field_schoolname1(inputs)
});
export { _field_schoolname1 as "_field_schoolName" }